import { render, staticRenderFns } from "./CateList.vue?vue&type=template&id=4679da2c&scoped=true&"
import script from "./CateList.vue?vue&type=script&lang=js&"
export * from "./CateList.vue?vue&type=script&lang=js&"
import style0 from "./CateList.vue?vue&type=style&index=0&id=4679da2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679da2c",
  null
  
)

export default component.exports